<div class="flex h-screen bg-surface-canvas">
  <pp-sidebar></pp-sidebar>

  <div class="flex-1 flex flex-col min-w-0">
    <pp-topbar></pp-topbar>
    <pp-secondary-nav></pp-secondary-nav>

    <main class="flex-1 overflow-y-auto p-6">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
